/**
 * checkbox
 * @author yangqizhang@medlinker.com
 */

import React, { forwardRef, ChangeEvent, MouseEvent, Ref } from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

interface Props {
  inputRef?: Ref<HTMLInputElement>;
  checked: boolean;
  className?: string;
  checkedClassName?: string;
  onChange?: (checked: boolean) => void;
}

function Checkbox(props: Props) {
  const { checked, onChange, inputRef, checkedClassName } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  const handleClickInput = (e: MouseEvent<HTMLInputElement>) => {
    // input 点击事件会冒泡到 外层 label，为了避免重复触发 label 的 click 事件，故禁之。
    e.stopPropagation();
  };

  return (
    <label
      className={cn(styles.checkbox, props.className, {
        [checkedClassName || styles.checked]: props.checked,
      })}
    >
      <input
        ref={inputRef}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        onClick={handleClickInput}
      />
    </label>
  );
}

export default forwardRef<HTMLInputElement, Omit<Props, 'inputRef'>>(
  (props: Props, ref) => {
    const { inputRef, ...rest } = props;

    return <Checkbox {...rest} inputRef={ref} />;
  }
);
